import React, { useEffect, useState } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import { amApi } from "../../../../../api/apiHelper";
import moment from "moment";

const data = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

function AmealiogeneralAnalytics() {

  const [downloadBtnData,setDownloadBtnData] = useState([]);

  const [userRegistrations,setuserRegistraions] = useState([]);
  
  const [dateQuery, setDateQuery] = useState({});

  const [type,setType] = useState("THISMONTH")

  const [dateQueryReg, setDateQueryReg] = useState({});

  const [typeReg,setTypeReg] = useState("THISMONTH")

  const DateForm = {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  };

  const onDateChangeHandler = (data, type,selectedDateType) => {
    setDateQuery(data);
    setType(selectedDateType);
  };

  const onDateChangeHandlerRegistrations = (data, type,selectedDateType) => {
    setDateQueryReg(data);
    setTypeReg(selectedDateType);
  };


  const fetchData = async (date,type) => {
    try {
      const response = await amApi.get(
        `adminPageStats/APP_DOWNLOAD?startDate=${date.startDate}&endDate=${date.endDate}&type=${type}`
      );
      if (response && response.data) {
        setDownloadBtnData(response.data);
      
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if(dateQuery || DateForm)
    fetchData(dateQuery.startDate === "undefined" ? DateForm : dateQuery,type);
  }, [dateQuery]);


  
  const fetchDataReg = async (date,type) => {
    try {
      const response = await amApi.get(
        `adminPageStats/REGISTER_WEBAPP?startDate=${date.startDate}&endDate=${date.endDate}&type=${type}`
      );
      if (response && response.data) {
        setuserRegistraions(response.data);
       
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if(dateQueryReg || DateForm)
    fetchDataReg(dateQueryReg.startDate === "undefined" ? DateForm : dateQueryReg,typeReg);
  }, [dateQueryReg]);
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex  align-items-center justify-content-between pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Amealio General</div>
              </div>
              <div className="row">
                <div className="col-6" style={{backgroundColor:"whitesmoke",borderRadius:"10px"}}>
                  <div className="d-flex justify-content-between my-3">
                    <div>
                      <div className="f14-400 opacity-50">Web App Activity</div>
                      <div className="f16-700">App Download Button Engagements</div>
                    </div>
                    <div>
                    <SelectFilter onDateChange={onDateChangeHandler} excludeOptions={true} defaultSelected={"THISMONTH"}/>
                    </div>
                  </div>
                 <div style={{width:'100%'}}>
                 <AreaChart
                   width={600}
                   height={400}
                   data={downloadBtnData}
                   margin={{
                     top: 10,
                     right: 30,
                     left: 0,
                     bottom: 0,
                   }}
                 >
                   <defs>
                     <linearGradient
                       id="colorGradient"
                       x1="0"
                       y1="0"
                       x2="0"
                       y2="1"
                     >
                       <stop
                         offset="5%"
                         stopColor="#EE3A23"
                         stopOpacity={1}
                       />
                       <stop
                         offset="95%"
                         stopColor="#EE3A23"
                         stopOpacity={0}
                       />
                     </linearGradient>
                   </defs>
                   <CartesianGrid strokeDasharray="3 3" />
                   <XAxis dataKey="xAxis" />
                   <YAxis dataKey="count"/>
                   <Tooltip />
                   <Area
                     type="linear"
                     dataKey="count"
                     stroke="#EE3A23"
                     fill="url(#colorGradient)"
                   />
                 </AreaChart>

                 </div>
                  
                </div>
                <div className="col-6" style={{backgroundColor:"whitesmoke",borderRadius:"10px"}}>
                  <div className="d-flex justify-content-between my-3">
                    <div>
                      <div className="f14-400 opacity-50">Web App Activity</div>
                      <div className="f16-700">User Registrations </div>
                    </div>
                    <div>
                    <SelectFilter onDateChange={onDateChangeHandlerRegistrations} excludeOptions={true} defaultSelected={"THISMONTH"}/>
                    </div>
                  </div>
                 <div>
                 <AreaChart
                   width={600}
                   height={400}
                   data={userRegistrations}
                   margin={{
                     top: 10,
                     right: 30,
                     left: 0,
                     bottom: 0,
                   }}
                 >
                   <defs>
                     <linearGradient
                       id="colorGradient"
                       x1="0"
                       y1="0"
                       x2="0"
                       y2="1"
                     >
                       <stop
                         offset="5%"
                         stopColor="#EE3A23"
                         stopOpacity={1}
                       />
                       <stop
                         offset="95%"
                         stopColor="#EE3A23"
                         stopOpacity={0}
                       />
                     </linearGradient>
                   </defs>
                   <CartesianGrid strokeDasharray="3 3" />
                   <XAxis dataKey="xAxis" />
                   <YAxis dataKey="count"/>
                   <Tooltip />
                   <Area
                     type="linear"
                     dataKey="count"
                     stroke="#EE3A23"
                     fill="url(#colorGradient)"
                   />
                 </AreaChart>

                 </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AmealiogeneralAnalytics;
